import { render, staticRenderFns } from "./HistoryLearningResultEntranceContent.vue?vue&type=template&id=31b573ad&scoped=true&lang=pug&"
import script from "./HistoryLearningResultEntranceContent.vue?vue&type=script&lang=ts&"
export * from "./HistoryLearningResultEntranceContent.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryLearningResultEntranceContent.vue?vue&type=style&index=0&id=31b573ad&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b573ad",
  null
  
)

export default component.exports